/**
 * The possible types of keydown events.
 */
export const KeyboardKeyEvents = {
    ENTER: 'Enter',
    RETURN: 'Return',
    SPACEBAR: ' ',
    SHIFT: 'Shift',
    ESCAPE: 'Escape',
    ARROWRIGHT: 'ArrowRight',
    ARROWLEFT: 'ArrowLeft',
    ARROWUP: 'ArrowUp',
    ARROWDOWN: 'ArrowDown',
    HOME: 'Home',
    END: 'End',
    TAB: 'Tab',
};
//# sourceMappingURL=keyboard.js.map